<template>
  <div class="author-library">
    <div class="author-library-content">
      <div>
        <div class="left-institution">
          <div class="title theme-title">机构</div>
          <div class="institution-list">
            <div
              class="institution-item ellipsis-aRow"
              :class="currentIndex == 999 ? 'active' : ''"
              @click="getAllDept"
            >
              全部
            </div>
            <div
              class="institution-item"
              :class="currentIndex == index ? 'active' : ''"
              v-for="(item, index) in deptList"
              :key="index"
              @click="getDept(item.deptId, index)"
            >
              <el-tooltip
                :content="item.deptName"
                placement="top"
                v-ak-tooltip-auto-show
              >
                <span class="ellipsis-aRow" style="width:256px;display:inline-block;">{{ item.deptName }}</span>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="right-authors">
        <div class="custom-search">
          <input
            type="text"
            class="custom-input"
            placeholder="请输入"
            v-model.trim="queryParams.authorName"
            @keyup.enter="handleQuery"
          />
          <el-button
            type="primary"
            @click="handleQuery"
            icon="el-icon-search"
            class="custom-button"
            >搜索</el-button
          >
        </div>
        <div class="author-list" v-loading="loading">
          <div
            class="author-box"
            v-for="(item, index) in authorList"
            :key="index"
          >
            <div
              class="author-avatar flex-center"
              @click="toDetail(item.authorId)"
            >
              <img
                :src="
                  item.authorPortrait == null ? defaultImg : item.authorPortrait
                "
                alt=""
              />
            </div>
            <div class="right-author-content">
              <div class="name" @click="toDetail(item.authorId)">
                <span class="ellipsis-aRow">{{ item.authorName }}</span>
              </div>
              <div class="author-info">
                <div>
                  <span>学术领域：</span>

                  <el-tooltip
                    :content="item.academicField"
                    placement="top"
                    v-ak-tooltip-auto-show
                  >
                    <span class="ellipsis-aRow">{{
                      item.academicField ? item.academicField : "-"
                    }}</span>
                  </el-tooltip>
                </div>
                <div>
                  <span>商品数量：</span>
                  <span class="ellipsis-aRow">{{ item.resourceCount }}本</span>
                </div>
                <div>
                  <span>所属机构：</span>
                  <el-tooltip
                    :content="item.cpName"
                    placement="top"
                    v-ak-tooltip-auto-show
                  >
                    <span class="ellipsis-aRow">{{ item.cpName }}</span>
                  </el-tooltip>
                </div>
              </div>
              <p class="ellipsis-twoRow">{{ item.introduction }}</p>
            </div>
          </div>
        </div>
        <noData v-if="total == 0"></noData>
        <!-- <el-pagination
          v-show="total > 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="queryParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="queryParams.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination> -->
        <div class="pagination-box" v-show="total > 0">
          <el-pagination
            class="ou-pagination"
            background
            hide-on-single-page
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="queryParams.pageNum"
            :page-sizes="[10, 20, 30, 40, 50]"
            :page-size="queryParams.pageSize"
            layout="total, prev, pager, next, sizes, jumper, slot"
            :total="total"
          >
            <el-button @click="getList()" class="ou-page-go">GO</el-button>
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import noData from "@/components/noData.vue";
import { listCoagency } from "@/api/coagency/coagency";
import { ListAuthor } from "@/api/authorLibrary/authorLibrary";
export default {
  data() {
    return {
      loading: true,
      currentIndex: 999,
      defaultImg: require("@/assets/images/default-avatar.jpg"),
      total: 0,
      deptList: [], //左侧机构列表
      authorList: [], //右侧作者列表
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        deptId: null,
        authorName: null,
      },
    };
  },
  components: { noData },
  watch: {
    //监听
    $route(to, from) {
      //路由变化方式，当路由跳转到作者库时，方法就会执行
     if(to.path == '/authorLibrary/index'){
       this.getList();
     }
    },
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      //左侧机构列表
      listCoagency().then((res) => {
        // console.log(res)
        if (res.code == 200) {
          this.deptList = res.rows;
        }
      });
      // 右侧作者列表
      ListAuthor(this.queryParams).then((res) => {
        if (res.code == 200) {
          this.loading = false;
          this.authorList = res.rows;
          this.total = res.total;
        }
      });
    },
    getAllDept() {
      this.currentIndex = 999;
      this.queryParams = {
        pageNum: 1,
        pageSize: 10,
        deptId: null,
        authorName: null,
      };
      this.getList();
    },
    getDept(id, index) {
      this.currentIndex = index;
      this.queryParams.deptId = id;
      this.queryParams.pageNum = 1;
      this.getList();
    },
    toDetail(id) {
      this.$router.push({
        path: "/authorLibrary/authorDetail",
        query: { authorId: id },
      });
    },
    // 搜索按钮操作
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    //每页条数
    handleSizeChange(val) {
      this.queryParams.pageSize = val;
      this.getList();
    },
    //当前页数
    handleCurrentChange(val) {
      this.queryParams.pageNum = val;
      this.getList();
    },
  },
};
</script>
<style scoped lang='scss'>
.author-library {
  height: auto;
  padding-bottom: 40px;
  // background: #FBFBFB;
  .author-library-content {
    width: 1400px;
    min-height: 300px;
    margin: 0 auto;
    display: flex;
    box-sizing: border-box;
    .left-institution {
      width: 304px;
      // height: 250px;
      background: #fffefd;
      margin-right: 16px;
      box-sizing: border-box;
      padding: 16px 8px 0;
      .title {
        margin-left: 6px;
      }
      .institution-list {
        margin-top: 10px;
        box-sizing: border-box;
        .institution-item {
          padding: 16px 10px 16px 22px;
          box-sizing: border-box;
          border-top: 1px solid #f2f2f2;
          font-size: 14px;
          font-family: PingFang SC;
          font-weight: 400;
          color: #333333;
          cursor: pointer;
        }
        .active {
          color: #2e9adb;
        }
      }
    }
    .right-authors {
      width: 1080px;
      min-height: 300px;
      background: #fffefd;
      box-sizing: border-box;
      padding: 16px 30px;
      .author-list {
        .author-box {
          display: flex;
          align-items: center;
          box-sizing: border-box;
          padding: 30px 0;
          border-bottom: 1px solid #f2f2f2;
          .author-avatar {
            width: 130px;
            height: 130px;
            margin-right: 40px;
            cursor: pointer;
            img {
              width: 100%;
              height: 100%;
              border-radius: 50%;
            }
          }
          .right-author-content {
            width: 820px;
            .name {
              display: flex;
              span {
                display: inline-block;
                max-width: 700px;
              }

              font-size: 16px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #333333;
              margin-bottom: 20px;
              cursor: pointer;
            }
            .name > span:hover {
              color: #1690ff;
              text-decoration: underline;
            }
            .author-info {
              width: 730px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #666666;
              margin-bottom: 20px;
              > div {
                display: flex;
                align-items: center;
                span:last-child {
                  display: block;
                }
              }
              > div:nth-of-type(1) {
                span:last-child {
                  width: 110px;
                }
              }
              > div:nth-of-type(3) {
                span:last-child {
                  width: 180px;
                }
              }
            }
            p {
              font-size: 14px;
              font-family: PingFang SC;
              font-weight: 400;
              color: #666666;
              line-height: 26px;
            }
          }
        }
      }
      .pagination-box {
        text-align: right;
        margin: 25px 0 20px;
      }
    }
  }
}
</style>
